import axios from 'axios';

const config = () => ({headers: {Authorization: `Bearer ${localStorage.getItem('userToken')}`, 'App-Network': localStorage.getItem('networkId')}});
const base = () => `${process.env.REACT_APP_API_HOST}/api/v2/production-scheduling`;
export const assignmentGet = (path, params, signal) => axios.get(`${base()}${path}`, {...config(), params, signal}).then(r => r.data.data);
export const assignmentPost = data => axios.post(`${base()}/assign`, data, config()).then(r => r.data.data);
export const productionItemDragType = 'application/x-trackie-production-item';
export function droppedProductionItem(event) {
  try {
    const data = JSON.parse(event.dataTransfer.getData(productionItemDragType) || event.dataTransfer.getData('application/json') || '{}');
    return data.source === 'production-item-calendar-list' && Number.isInteger(Number(data.id)) && Number(data.id) > 0 ? Number(data.id) : null;
  } catch { return null; }
}
export function assignmentError(error, fallback) {
  const response = error.response?.data;
  const messages = response?.data && !Array.isArray(response.data) ? Object.values(response.data).flat().filter(v => typeof v === 'string') : [];
  return messages.join(' · ') || response?.message || fallback;
}
